import React, { useState } from "react";
import { Box, useMediaQuery } from "@mui/material";
import ReactPlayer from "react-player";
import { useTheme } from "@mui/material/styles";
import { H6 } from "../../components/typography";
import { COLORS } from "../../theme";
import { getScoreText, getScoreVideoName } from "../../utils";

import {imgResultsPointsBg} from "../../assets/images/results_points_bg";
import {imgChallengeFriend} from "../../assets/images/challenge_friend";
import {imgSelectQuiz} from "../../assets/images/select_quiz";
import {imgStartPage0} from "../../assets/images/start_page_0";
import {imgStartPage1} from "../../assets/images/start_page_1";

const ScoreBoard = (props) => {
  const [scoreVideoPlayed, setScoreVideoPlayed] = useState(false);
  const handleChallengeFriend = () => {
    if (props.handleChallengeFriend) props.handleChallengeFriend();
  };

  const handleSelectQuiz = () => {
    if (props.handleSelectQuiz) props.handleSelectQuiz();
  };

  const handleStartPage = () => {
    window.parent.window.location.href = "https://spelarguiden.com/module3";
  };

  const onScoreVideoEnd = () => {
    setScoreVideoPlayed(true);
  };

  const isMobile = useMediaQuery(useTheme().breakpoints.down("md"), {
    noSsr: true,
  });

  return (
     <Box sx={{
      marginTop: { xs: 4, md: 5 },
      marginLeft: { xs: 4, md: 10 },
      marginRight: { xs: 4, md: 10 },
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      height: "inherit",
    }}>
      <ReactPlayer
        url={getScoreVideoName(props.totalAnswersRight)}
        controls={false}
        playing
        muted
        playsinline
        height={isMobile ? 100 : 200}
        onEnded={onScoreVideoEnd}
      />

      <H6
        color={COLORS.white}
        marginTop={'16px !important'}
        dangerouslySetInnerHTML={{
          __html: `Du svarade rätt på <span style='color:#FFDE00'>${props.totalAnswersRight} av 10 frågor</span> och fick totalt`,
        }}
      />

      <Box
        sx={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: { xs: 1.5, md: 4 },
        }}
      >
        <Box
          component="img"
          sx={{
            height: { xs: 50, md: 50 },
            width: { xs: 180, md: 180 },
            position: "absolute",
            zIndex: 1,
          }}
          alt="result points"
          src={imgResultsPointsBg}
        />

        <span
          style={{
            fontWeight: "bold",
            color: COLORS.yellow,
            fontFamily: "'ATGRubrik'",
            zIndex: 10,
            fontSize: 20
          }}
        >
          {parseInt(props.score)} POÄNG!
        </span>
      </Box>

      <H6
        marginTop={50}
        color={COLORS.white}
        dangerouslySetInnerHTML={{
          __html: getScoreText(props.totalAnswersRight),
        }}
      />

      <Box
        component="img"
        sx={{
          height: { xs: 50, md: 75 },
          width: { xs: 180, md: 240 },
          marginTop: { xs: 1.5, md: 4 },
        }}
        alt="challenge friend button"
        src={imgChallengeFriend}
        onClick={handleChallengeFriend}
      />

      <Box
        component="img"
        sx={{
          height: { xs: 50, md: 75 },
          width: { xs: 180, md: 240 },
          marginTop: { xs: 1.5, md: 4 },
        }}
        alt="select quiz button"
        src={imgSelectQuiz}
        onClick={handleSelectQuiz}
      />

      <Box
        component="img"
        sx={{
          height: { xs: 50, md: 75 },
          width: { xs: 180, md: 240 },
          marginTop: { xs: 1.5, md: 4 },
        }}
        alt="start page button"
        src={scoreVideoPlayed ? imgStartPage1 : imgStartPage0}
        onClick={scoreVideoPlayed ? handleStartPage : null}
      />
    </Box>
  );
};

export default ScoreBoard;
